<template>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <DynamicVisibility  ref="dynamicVisibility">
        <template #primary>
          <AppsOverviewComponent @toggle-visibility="toggleVisibility" />
        </template>

        <template #secondary>
          <LibraryComponent />
        </template>
      </DynamicVisibility>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/user/layout/TopNavbar.vue";
import AppsOverviewComponent from "@/components/user/viewComponent/apps/AppsOverviewComponent.vue";
import DynamicVisibility from "@/components/custom/visibility/DynamicVisibility.vue";
import LibraryComponent from "@/components/user/viewComponent/apps/LibraryComponent.vue";

export default {
  name: "AppsViewComponent",
  components: {
    TopNavbar,
    LibraryComponent,
    AppsOverviewComponent,
    DynamicVisibility,
  },
  methods: {
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>
